module.exports = __webpack_public_path__ + "static/media/arizzona.22f9117b.png";